import { Scope } from '../../../enums/scope'
import { isAuthorized } from '../../../utils/isAuthorized'

export const useIsAnnualReportAvailable = () => {
  const isAvailable = isAuthorized(Scope.AnnualReportRead, false, true)

  return isAvailable
}
